export default __webpack_public_path__ + "static/media/html_logo.2fcf94ab.png";